import { useAuth } from "@/hooks/useAuth";
import { useLingui } from "@lingui/react/macro";
import { Button } from "@/components/ui/button";
import { Pencil, CreditCard } from "lucide-react";

export function OrgHeader({ tablet = false }: { tablet?: boolean }) {
  const { t } = useLingui();
  const { user } = useAuth();
  const orgName = user?.organization?.name ?? "";

  if (tablet) {
    return (
      <div className="flex h-15.5 items-center gap-3 border-b border-(--color-border) px-5">
        <h1 className="text-[1.375rem] font-extrabold tracking-tight leading-none text-(--color-text-primary) truncate">
          {orgName}
        </h1>
        {user?.organization && (
          <span className="shrink-0 bg-(--color-warning-bg) text-(--color-warning-text) text-[0.6875rem] font-bold px-2.5 py-0.5 rounded-full">
            {t`Pro`}
          </span>
        )}
        <div className="ml-auto flex items-center gap-2 shrink-0">
          <Button variant="outline" size="sm" disabled className="h-10 gap-2 rounded-[10px]">
            <Pencil className="size-4" />
            {t`Edit org`}
          </Button>
          <Button size="sm" disabled className="h-10 gap-2 rounded-[10px]">
            <CreditCard className="size-4" />
            {t`Manage subscription`}
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-between px-1">
      <div className="flex items-center gap-3">
        <h1 className="text-5xl font-bold tracking-tight text-(--color-text-primary)">
          {orgName}
        </h1>
        {user?.organization && (
          <span className="bg-(--color-warning-bg) text-(--color-warning-text) text-xs font-semibold px-2.5 py-1 rounded-full">
            {t`Pro`}
          </span>
        )}
      </div>
      <div className="flex gap-2">
        <Button variant="outline" disabled className="gap-2 rounded-[10px]">
          <Pencil className="size-4" />
          {t`Edit org`}
        </Button>
        <Button disabled className="gap-2 rounded-[10px]">
          <CreditCard className="size-4" />
          {t`Manage subscription`}
        </Button>
      </div>
    </div>
  );
}
